import React from 'react';

import { Script } from 'gatsby';

import { CustomRpcModal } from '../../components/CustomRpcModal';
import SEO from '../../components/SEO';
import WidgetHolder from '../../components/WidgetHolder';

import { DlnWidget } from './DlnWidget';

const DlnSwap = () => {
  return (
    <>
      <Script
        src="https://app.debridge.finance/assets/scripts/widget.js"
        id="debridge-widget"
      />
      <SEO page="swap" />
      <CustomRpcModal />

      <WidgetHolder>
        <DlnWidget />
      </WidgetHolder>
    </>
  );
};

export default DlnSwap;
